import React, { useState } from "react";
import "./App.css";
import "./styles/globals.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "./components/ui/sonner";
import ModernHeader from "./components/modern/ModernHeader";
import ModernFooter from "./components/modern/ModernFooter";
import SearchModal from "./components/SearchModal";
import ScrollToTop from "./components/ScrollToTop";
import ModernHome from "./pages/ModernHome";
import ArticlesListPage from "./pages/ArticlesListPage";
import ArticlePage from "./pages/ArticlePage";
import SimulatorsListPage from "./pages/SimulatorsListPage";
import SimulatorPage from "./pages/SimulatorPage";
import AdvancedSearch from "./components/search/AdvancedSearch";
import ApplicationPage from "./pages/ApplicationPage";

function App() {
  const [searchModalOpen, setSearchModalOpen] = useState(false);

  const handleSearchToggle = () => {
    setSearchModalOpen(!searchModalOpen);
  };

  return (
    <HelmetProvider>
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <div className="min-h-screen flex flex-col">
          <ModernHeader onSearchToggle={handleSearchToggle} />
          
          <main className="flex-1">
            <Routes>
              <Route path="/" element={<ModernHome />} />
              <Route path="/articles" element={<ArticlesListPage />} />
              <Route path="/article/:slug" element={<ArticlePage />} />
              <Route path="/simulateurs" element={<SimulatorsListPage />} />
              <Route path="/simulateur/:id" element={<SimulatorPage />} />
              <Route path="/recherche" element={<AdvancedSearch />} />
              <Route path="/application" element={<ApplicationPage />} />
            </Routes>
          </main>

          <ModernFooter />
          
          <SearchModal 
            open={searchModalOpen} 
            onOpenChange={setSearchModalOpen} 
          />
          
          <Toaster />
        </div>
      </BrowserRouter>
    </div>
    </HelmetProvider>
  );
}

export default App;
